import { computed } from 'vue'
import { useRoute } from '#app/composables/router'
import { DEFAULT_ODOSCOPE_SORT_VALUE_KEY } from '~/config/defaultConfigs'
import { getOdoscopeSortByValue } from '../utils/odoscopeSort'

export default () => {
  const defaultQuery = ''

  const route = useRoute()

  const sort = computed(() => {
    const query = Array.isArray(route.query.sort)
      ? route.query.sort[0]
      : route.query.sort

    return query || defaultQuery
  })
  const selectedSort = computed(() =>
    getOdoscopeSortByValue(sort.value, DEFAULT_ODOSCOPE_SORT_VALUE_KEY),
  )

  const isDefaultSort = computed(
    () =>
      selectedSort.value ===
      getOdoscopeSortByValue(defaultQuery, DEFAULT_ODOSCOPE_SORT_VALUE_KEY),
  )

  const selectedSortName = computed(() => selectedSort.value.name)

  return { selectedSort, selectedSortName, isDefaultSort }
}
